// Owner: shell-nav (wave 2). Authenticated layout with the workspace rail (AppSidebar.dc.html): the app
// shell around every app route, with a 404 and an error state inside the shell.
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../lib/auth';
import { navQuery, queryClient, useMe } from '../lib/queries';
import { AppShell } from '../shell/AppShell';
import { PagePending, RouteError, ShellNotFound } from '../shell/states';

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ location }) => {
    // The rail's model loads alongside the first screen's data, not after it rendered.
    const me = await requireSession(location);
    void queryClient.prefetchQuery(navQuery);
    return me;
  },
  component: AppLayout,
  pendingComponent: PagePending,
  notFoundComponent: ShellNotFound,
  errorComponent: RouteError,
});

function AppLayout() {
  const me = useMe();
  // Everything below the layout belongs to one workspace: switching remounts the shell and the open
  // screen, so no mounted query keeps showing the previous workspace's data (review: stale Home).
  return (
    <AppShell key={me.workspace.id}>
      <Outlet />
    </AppShell>
  );
}
